module.exports = __webpack_public_path__ + "img/topback.0bcaef38.png";